import React from 'react';

export const PageNotFound: React.FC = () => {
    return <div>Page not found</div>;
};
